// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"d267c3e6","165":"b8bf394a","264":"ee8c2a77","423":"d79f9f71","634":"2df1d8a9","733":"a582b7ba","796":"5d5fc7a5","798":"7ea746aa","860":"c9deada0","896":"d523174d","942":"f2333d99"}[chunkId] + ".chunk.js";
};